import React from 'react'
import styled from 'styled-components'
import { Close } from '../../../assets/icons'
import { InputWrapper, Label, InputContainer, StyledInput } from './styled'

const ClearWrapper = styled.div`
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	z-index: 2;
`

const ClearButton = styled.button.attrs({ type: 'button' })`
	background: none;
	border: none;
	padding: 2px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.6;
	transition: opacity 0.2s;
	&:hover {
		opacity: 1;
	}
`

const DateRangeInput = React.forwardRef(
	({ value, onClick, onChange, onClear, placeholder, label, className }, ref) => (
		<InputWrapper fullWidth>
			{label && <Label>{label}</Label>}
			<InputContainer style={{ position: 'relative' }}>
				<StyledInput
					ref={ref}
					className={className}
					value={value || ''}
					onClick={onClick}
					onChange={onChange}
					placeholder={placeholder}
					readOnly
					style={{ paddingRight: value ? 36 : undefined }}
				/>
				{value && onClear && (
					<ClearWrapper>
						<ClearButton
							onMouseDown={e => {
								e.preventDefault()
								e.stopPropagation()
								onClear()
							}}
							aria-label="Limpiar fecha"
						>
							<Close />
						</ClearButton>
					</ClearWrapper>
				)}
			</InputContainer>
		</InputWrapper>
	)
)

DateRangeInput.displayName = 'DateRangeInput'

export default DateRangeInput
